export const state = {
    show: true,

    navItems: [
        {

            icon: "mdi-home",
            title: "الرئيسية",
            link: "/dashboard",
            code: 1000,
        },
        {
            icon: "mdi-magnify",
            title: "البحث العام",
            link: "/search",
            code: 26000,
        },
        {
            icon: "mdi-account-group",
            title: "ادارة الموظفين",
            link: "/employees",
            code: 2000,

        },
        {
            icon: "mdi-account-network",
            title: "تعيينات المدراء ",
            link: "/directorsAppointments",
            code: 8000,

        },
        {
            icon: "mdi-doctor",
            title: " صحة الموظفين",
            link: "/employeeHealth",
            code: 3000,

        },
        {
            icon: "mdi-cast-education",
            title: " مؤهلات الموظفين",
            link: "/employeeQualifications",
            code: 4000,

        },
        {
            icon: "mdi-certificate-outline",
            title: " دورات الموظفين",
            link: "/employeeCourses",
            code: 5000,

        },
        {
            icon: "mdi-certificate-outline",
            title: " الشكاوي والمقترحات ",
            link: "/complaints",
            code: 24000,

        },
        {
            icon: "mdi-bell",
            title: "ادارة التنبيهات ",
            link: "/notifications", code: 23000,
        },


        {
            icon: "mdi-account-details-outline",
            title: "اجراءات الموظفين",
            group: "settings",
            codes: [16000, 21000, 22000, 30000, 31000, 29000, 32000],

            subNavs: [

                {
                    icon: "mdi-calendar-blank",
                    title: "ادارة اجازات الموظفين",
                    link: "/employeeLeaves", code: 16000,

                },
                {
                    icon: "mdi-file-star-outline",
                    // icon: "mdi-account-multiple-check-outline",
                    title: "ادارة الترقيات ",
                    link: "/promotions", code: 21000,

                },
                {
                    icon: "mdi-package-up",
                    title: "ادارة العلاوات ",
                    link: "/bonuses", code: 22000,

                },
                {
                    icon: "mdi-file-cancel-outline",
                    title: "ادارة التظلمات ",
                    link: "/grievances", code: 31000,

                },
                {
                    icon: "mdi-clipboard-clock-outline",
                    title: "ادارة التقاعدات ",
                    link: "/retirements", code: 30000,

                },
                {
                    icon: "mdi-text-box-remove-outline",
                    title: "ادارة انهاء الخدمة",
                    link: "/employeeTermination", code: 29000,

                }, 
                {
                    icon: "mdi-text-box-remove-outline",
                    title: "إدارة تصحيح الاجراءات ",
                    link: "/employeesCorrection", code: 32000,
                },

            ],

        },
        {
            icon: "mdi-account-cog",
            title: "العمليات",
            group: "settings",
            codes: [17000, 18000, 19000, 20000],

            subNavs: [
                {
                    icon: "mdi-clipboard-text",
                    title: "ادارة التكاليف ",
                    link: "/assignments",
                    code: 17000,
                },
                {
                    icon: "mdi-transit-transfer",
                    title: "ادارة نقل الموظفين",
                    link: "/employeeTransfers", code: 18000,

                },
                {
                    icon: "mdi-swap-horizontal",
                    title: "ادارة ندب الموظفين",
                    link: "/employeeDelegations", code: 19000,

                },
                {
                    icon: "mdi-swap-horizontal-circle-outline",
                    title: "ادارة ندب الدرجات الوظيفية",
                    link: "/degreeDelegnations", code: 20000,

                },


            ],

        },
        {
            icon: "mdi-cog-outline",
            title: "الاعدادات",
            group: "settings",
            codes: [6000, 7000, 9000, 25000, 10000, 33000, 34000, 34103, 35000, 36000, 37000, 38000, 39000, 40000, 40003],

            subNavs: [
                {
                    icon: "mdi-card-account-details-outline",
                    title: "بيانات المؤسسة",
                    link: "/organization",
                    code: 39000,
                },
                {
                    icon: "mdi-domain",
                    title: "الإدارات",
                    link: "/administrations",
                    code: 6000,
                },
                {
                    icon: "mdi-office-building",
                    title: "الاقسام",
                    link: "/departments",
                    code: 7000,
                }, {
                    icon: "mdi-source-branch",
                    title: "الوحدات",
                    link: "/units",
                    code: 25000,
                },
                {
                    icon: "mdi-star",
                    title: "الملاك الوظيفي",
                    link: "/jobGrades",
                    code: 10000,
                },

                {
                    icon: "mdi-account-group-outline",
                    title: "المستخدمين",
                    link: "/users",
                    code: 9000,
                },

                {
                    icon: "mdi-clipboard-check-outline",
                    title: "مبررات وتصحيحات الحضور",
                    link: "/attendanceAdjustments",
                    codes: [40000, 40003],
                },
                {
                    icon: "mdi-fingerprint",
                    title: "أجهزة البصمة",
                    link: "/attendanceDevices",
                    code: 34000,
                },
                {
                    icon: "mdi-clock-check-outline",
                    title: "سجل البصمات",
                    link: "/attendancePunches",
                    code: 34103,
                },
                {
                    icon: "mdi-calendar-clock",
                    title: "جداول الدوام والمناوبات",
                    link: "/workSchedules",
                    // Schedules, assignments or special periods: the screen shows the tabs allowed.
                    codes: [35000, 36000, 37000],
                },
                {
                    icon: "mdi-calendar-star",
                    title: "العطلات الرسمية وغير الرسمية",
                    link: "/holidays",
                    code: 38000,
                },
                {
                    icon: "mdi-history",
                    title: "سجل العمليات",
                    link: "/auditLogs",
                    code: 33000,
                },


            ],

        },
        {
            icon: "mdi-file-cog-outline",
            title: "قوائم مساعدة",
            group: "settings",
            codes: [11000, 12000, 13000, 14000, 15000],
            subNavs: [
                {
                    icon: "mdi-family-tree",
                    title: "المجموعات الوظيفية",
                    link: "/jobGroups",
                    code: 11000,

                },
                {
                    icon: "mdi-briefcase-outline",
                    title: " الوظائف",
                    link: "/jobs",
                    code: 12000,
                },

                {
                    icon: "mdi-school",
                    title: "الجامعات",
                    link: "/universities",
                    code: 13000,
                },
                {
                    icon: "mdi-text-box-outline",
                    title: "التخصصات",
                    link: "/specialties",
                    code: 14000,
                },
                {
                    icon: "mdi-bank",
                    title: "المصارف",
                    link: "/banks",
                    code: 15000,
                },
                {
                    icon: "mdi-domain",
                    title: "المحلات",
                    link: "/localities",
                    code: 28000,
                },
                //   {
                //     icon: "mdi-account-cog",
                //     title: "حسابات الموظفين",
                //     link: "/employeeAccounts",
                // },

            ],

        }, {
            icon: "mdi-file-chart-outline",
            title: "التقارير",
            group: "reports",
            codes: [27001, 27002, 27003, 27004, 27005, 27006, 27007, 27008, 27009, 27010],

            subNavs: [
                {
                    icon: "",
                    title: "كشف الحضور اليومي",
                    link: "/attendanceDailyReport",
                    code: 27009,
                },
                {
                    icon: "",
                    title: "تقرير نهاية الشهر (الحضور)",
                    link: "/attendanceMonthlyReport",
                    code: 27009,
                },
                {
                    icon: "",
                    title: "تقرير الحضور بالفرد",
                    link: "/attendanceEmployeeReport",
                    code: 27010,
                },
                {
                    icon: "",
                    title: "الاجازات السنوية",
                    link: "/vacationsReport",
                    code: 27001,

                },
                {
                    icon: "",
                    title: "العلاوات السنوية",
                    link: "/bonusesReport",
                    code: 27002,

                },
                {
                    icon: "",
                    title: "تقرير الدرجات الوظيفية",
                    link: "/correlatorReport",
                    code: 27004,

                },
                {
                    icon: "",
                    title: "تقرير بالاطباء و الاداريين",
                    link: "/employeesJobs",
                    code: 27003,

                },
                {
                    icon: "",
                    title: "تقرير اجازات التقاعد",
                    link: "/retirementReport",
                    code: 27005,

                },
                {
                    icon: "",
                    title: "تقرير الملاك الوظيفي للموظفين",
                    link: "/employeesJobGradesReport",
                    code: 27006,

                },
                {
                    icon: "",
                    title: "تقرير مؤهلات الموظفين",
                    link: "/qualificationReport",
                    code: 27007,

                },
                {
                    icon: "",
                    title: "تقرير دورات الموظفين",
                    link: "/employeeCoursesReport",
                    code: 27008,

                },
            ],

        },

    ],
};



export const getters = {
    isVisibleSideNav: (state) => state.show,
};

export const mutations = {
    setSidenavVisibility: (state, payload) => {
        state.show = payload !== undefined ? payload : !state.show;
    },
};

export const actions = {
    setSidenavVisibility: ({ commit }, payload) => {
        commit("setSidenavVisibility", payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
